import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { RoleService } from '../../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil, map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthenticationService } from 'src/modules/core/services/authentication';

@Component({
  selector: 'app-role-detail',
  templateUrl: './role-detail.component.html',
  styleUrls: ['./role-detail.component.scss'],
})
export class RoleDetailComponent implements OnInit {
  filter: AppFilter = new AppFilter();
  pending: boolean;
  success: any;
  error: any;
  permissions: Array<any> = [];
  selectedRolePermissions: Array<any>;
  role;
  roleId: string;
  permissionError: any;
  permissionLoading: boolean;
  organizationId: string;
  appUserId: string;
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'roleId',
        op: 'cn',
        data: '',
      },
    ],
  };
  public checkOptions = [{ value: 'true' }, { value: 'false' }];
  private unsubscribe$: Subject<void> = new Subject<void>();
  // organizationId:string
  constructor(
    private roleSvc: RoleService,
    private location: Location,
    private modalService: SuiModalService,
    // private formBuilder: FormBuilderService,
    private activateRoute: ActivatedRoute,
    private authSvc: AuthenticationService,
    private router: Router
  ) {
    this.organizationId = window.localStorage.getItem('organizationId');
    this.appUserId = JSON.parse(window.localStorage.getItem('user'))[
      'appUserId'
    ];
    this.activateRoute.params.subscribe((param) => {
      this.roleId = param['id'];
      this.filter = new AppFilter({ sidx: 'roleId', rows: 10 });
      this.searchFilter.rules[0].data = this.roleId;
      this.filter.filters = JSON.stringify(this.searchFilter);
      this.getRole();
    });

    // this.authSvc.user.subscribe((user) => {
    // 	this.appUserId = user.appUserId;
    // });
    // this.authSvc.organization.subscribe((org) => {
    // 	this.organizationId = org.organizationId;
    // });
    this.getRolePermission();
    // this.selectedRolePermissions = [];
    // let temp: Array<any> = [];
    // this.selectedRolePermissions = Object.values(
    // 	this.permissions.reduce((r, perm) => {
    // 		const key = perm.groupName;
    // 		r[key] = r[key] || { key: key, value: [] };
    // 		r[key].value.push(perm);
    // 		return r;
    // 	}, {})
    // );
  }
  editRole() {
    this.router.navigate(['/contractor/setting/role/edit', this.role.roleId]);
  }
  getRole() {
    this.pending = true;
    this.roleSvc
      .getRoles({
        organizationId: this.organizationId,
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.role = res['rows'][0];
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }
  getRolePermission() {
    this.permissionLoading = true;
    this.roleSvc
      .getRolePermission2(this.roleId)
      // .getRolePermission({
      // 	organizationId: this.organizationId,
      // 	appUserId: this.appUserId,
      // 	roleName: this.roleId
      // })
      .pipe(
        takeUntil(this.unsubscribe$),
        map((res) => res['data'])
      )
      .subscribe(
        (res: any[]) => {
          this.permissionLoading = false;
          this.selectedRolePermissions = res;
        },
        (error) => {
          this.permissionLoading = false;
          this.permissionError = error;
        }
      );
  }
  deleteRole() {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Role?',
          'Are you sure you want to delete this role?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.delete(this.role);
      })
      .onDeny(() => {});
  }
  delete(data) {
    // this.pending = true;
    this.pending = true;
    this.error = null;
    this.roleSvc
      .deleteRole({
        organizationId: this.organizationId,
        roleName: data.roleId,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'Role removed successfully';
          setTimeout(() => {
            this.router.navigateByUrl('/contractor/setting/role/list');
          }, 1500);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }
  goBack() {
    this.location.back();
  }

  ngOnInit(): void {}
}
